import auth from '../ducks/auth';
import { combineReducers } from 'redux';
import entities from '../ducks/entities';
import settings from '../ducks/settings';

/**
 * Global reducers to store all API flags.
 * Avoid having to manually set flags on each reducer making an API call.
 * see: https://medium.com/stashaway-engineering/react-redux-tips-better-way-to-handle-loading-flags-in-your-reducers-afda42a804c6
 */
const loadingReducer = (state = {}, action: any) => {
  const { type } = action;
  const matches = /(.*)_(PENDING|REJECTED|FULFILLED)/.exec(type);
  if (!matches) return state;

  const [, requestName, requestState] = matches;
  return {
    ...state,
    [requestName]: requestState === 'PENDING'
  };
};

const errorReducer = (state = {}, action: any) => {
  const { type, payload } = action;
  const matches = /(.*)_(PENDING|REJECTED)/.exec(type);

  if (!matches) return state;

  const [, requestName, requestState] = matches;
  return {
    ...state,
    [requestName]:
      requestState === 'REJECTED'
        ? payload?.message || payload || 'Generic error'
        : ''
  };
};

const rootReducer = combineReducers({
  auth,
  entities,
  settings,
  error: errorReducer,
  loading: loadingReducer
});

export default rootReducer;
